const JoinCourse = () => import('Views/course/join-course');
const ChooseCourse = () => import('Views/course/choose-course');
const CourseList = () => import('Views/course/course-list');
const CourseDetail = () => import('Views/course/course-detail');
const JoinSuccess = () => import('Views/course/join-success');

export default[
  { path: '/choose-course', component: ChooseCourse },
  { path: '/course-list', redirect: '/choose-course' },
  { path: '/course-list/:facultyId', redirect: to => ({ path: '/choose-course', query: { facultyId: to.params.facultyId } }) },
  { path: '/course-list/:facultyId/:courseId', component: CourseList },
  { path: '/course-detail/:facultyId/:courseId/:enrollmentId', component: CourseDetail },
  { path: '/join-course/:facultyId/:courseId/:enrollmentId', component: JoinCourse },
  { path: '/join-success/:facultyId/:courseId/:enrollmentId', component: JoinSuccess },
];



// WEBPACK FOOTER //
// ./src/router/course.js